import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'wh-backdrop',
  imports: [],
  templateUrl: './backdrop.html',
  styleUrl: './backdrop.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Backdrop {
  click = output();
}
